const initialState = {    
    //invoices search
    invoices: [],
    pickedPosProstor: {},
    pickedNapUred: {},
    pageSize: 10,
    activePage: 1,
    startDate: new Date(),
    endDate: new Date(),
    loadingInvoices: false,
    sortDirection: true,
    message: "Molimo pokrenite pretragu"
};


const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {

    case "CLIENT_MAP_INVOICES_MESSAGE":
        return{
            ...state,
            message: action.data
        }

    case "CLIENT_MAP_SORT_DIRECTION":
        return{
            ...state,
            sortDirection: !state.sortDirection       
        }

    case "CLIENT_MAP_LOADING_INVOICES":
        return{
            ...state,
            loadingInvoices: action.data        
        }

    case "CLIENT_MAP_START_DATE":
        return{
            ...state,
            startDate: action.data        
        }

    case "CLIENT_MAP_END_DATE":
        return{
            ...state,
            endDate: action.data        
        }

    case "CLIENT_MAP_PAGE_SIZE":
        return{
            ...state,
            pageSize: action.data        
        }

    case "CLIENT_MAP_ACTIVE_PAGE":
        return{
            ...state,
            activePage: action.data        
        }

    case "CLIENT_MAP_INVOICES":
        return{
            ...state,
            invoices: action.data      
        }
      

    case "CLIENT_MAP_PICKED_NAP_UREDAJ":
        return{
            ...state,
            pickedNapUred: action.data       
        }
    case "CLIENT_MAP_PICKED_POS_PROSTOR":
        return{
            ...state,
            pickedPosProstor: action.data       
        }

    default:
      // do ntohing
  }
  return newState;
};

export default reducer;
